export default __webpack_public_path__ + "static/media/chat-all.4c66e678.svg";